import Swal from 'sweetalert2/dist/sweetalert2.js';
import { MensajeServices } from '../Service/messages.services';

export class Alertas {
    constructor(private _MensajeServices: MensajeServices) {

    }

    public MostrarAlerta(titulo:string, claveMensaje: string, tipoAlerta:TiposAlerta, funcion?: Function): any {
        this._MensajeServices.CargarMensajes().then(data => {
            Swal.fire({
                title: titulo,
                icon: tipoAlerta,
                text: data[claveMensaje],
                confirmButtonText: 'Aceptar'
            }).then(data => {
                if (funcion !== undefined) {
                    if (data.isConfirmed) {
                        funcion();
                    }
                }
            })
        })
    }

    public MostrarAlertaConParametros(titulo:string, claveMensaje: string, tipoAlerta:TiposAlerta, parametros:[key:string, value:string][], funcion?: Function): any {
        this._MensajeServices.CargarMensajes().then(data => {
            var texto:string = data[claveMensaje];
            parametros.forEach(x => {
                texto = texto.replace(x[0], x[1]);
            })

            Swal.fire({
                title: titulo,
                icon: tipoAlerta,
                text: texto,
                confirmButtonText: 'Aceptar'
            }).then(data => {
                if (funcion !== undefined) {
                    if (data.isConfirmed) {
                        funcion();
                    }
                }
            })
        })
    }

    public MostrarAlertaConTexto(titulo:string, Mensaje: string, tipoAlerta:TiposAlerta, funcion?: Function): any {
        Swal.fire({
            title: titulo,
            icon: tipoAlerta,
            text: Mensaje,
            confirmButtonText: 'Aceptar'
        }).then(data => {
            if (funcion !== undefined) {
                if (data.isConfirmed) {
                    funcion();
                }
            }
        })
    }

    public MostrarAlertaHTMLConParametros(titulo:string, claveMensaje: string, tipoAlerta:TiposAlerta, parametros:[key:string, value:string][], funcion?: Function): any {
        this._MensajeServices.CargarMensajes().then(data => {
            var texto:string = data[claveMensaje];
            parametros.forEach(x => {
                texto = texto.replace(x[0], x[1]);
            })

            Swal.fire({
                title: titulo,
                icon: tipoAlerta,
                html: texto,
                confirmButtonText: 'Aceptar'
            }).then(data => {
                if (funcion !== undefined) {
                    if (data.isConfirmed) {
                        funcion();
                    }
                }
            })
        })
    }
    
}

export enum TiposAlerta{
    error = 'error',
    completado = 'success',
    informacion='info'
}